import { db } from '../firebaseInit'

export default {
  state: {
    personalNotes: [],
    projectNotes: [],
    taskNotes: [],
    leadNotes: []
  },
  mutations: {
    editLeadNote (state, payload) {
      state.leadNotes = payload
    },
    deletePersonalNote (state, payload) {
      state.personalNotes.splice(payload, 1)
    },
    addPersonalNote (state, payload) {
      state.personalNotes.push(payload)
    },
    personalNotes (state, payload) {
      state.personalNotes = payload
    },
    deleteProjectNote (state, payload) {
      state.projectNotes.splice(payload, 1)
    },
    deleteLeadNote (state, payload) {
      state.leadNotes.splice(payload, 1)
    },
    newLeadNote (state, payload) {
      state.leadNotes.push(payload)
    },
    getProjectNotes (state, payload) {
      state.projectNotes = payload
    },
    getLeadNotes (state, payload) {
      // state.leadNotes = payload
      state.leadNotes.push(payload)
    },
    addProjectNote (state, payload) {
      state.projectNotes.push(payload)
    }
  },
  actions: {
    editPersonalNote ({commit, getters, dispatch}, payload) {
      db.collection('users').doc(payload.user.id).collection('notes').doc(payload.note.id).update(payload.note)
    },
    editLeadNote ({commit, getters, dispatch}, payload) {
      const allOppsNotes = payload.selectedLead.allOpps[payload.selectedLead.opportunities.index].notes
      db.collection('contacts').doc(payload.selectedLead.id).update({ opportunities: payload.selectedLead.allOpps })
      .then(() => {
        const logData = { timestamp: new Date(), collection: 'lead notes', user_id: getters.user.id, record_id: payload.selectedLead.id, changed_from: payload.fullNote, changed_to: payload.note, message: getters.user.first_name + ' edited the note (' + payload.fullNote.note + ') from the lead: ' + payload.selectedLead.first_name + ' ' + payload.selectedLead.last_name, icon: 'library_books' }
        dispatch('commitLog', logData)
        payload.selectedLead.opportunities.notes = allOppsNotes
        dispatch('getLeadNotes', payload.selectedLead)
        dispatch('updateEditedNote', {id: payload.selectedLead.id, notes: allOppsNotes})
      })
    },
    deletePersonalNote ({commit, state}, payload) { // payload: {note: note, user: this.user}
      db.collection('users').doc(payload.user.id).collection('notes').doc(payload.note.id).update({deleted: true})
      .then(() => {
        const index = state.personalNotes.findIndex(i => i.id === payload.note.id)
        commit('deletePersonalNote', index)
      })
    },
    addPersonalNote ({commit, state}, payload) { // user: this.user, note: this.newNote, flagged: this.flagNote
      db.collection('users').doc(payload.user.id).collection('notes').add({note: payload.note, flagged: payload.flagged, timestamp: new Date(), deleted: false})
      .then((res) => {
        commit('addPersonalNote', {id: res.id, note: payload.note, flagged: payload.flagged, deleted: false, timestamp: {seconds: new Date().getTime()}})
      })
    },
    personalNotes ({commit, state}, payload) { // payload = user.id
      let personalNotes = []
      db.collection('users').doc(payload).collection('notes').where('deleted', '==', false).get()
      .then(notes => {
        notes.forEach(note => {
          personalNotes.push({...note.data(), id: note.id})
        })
      })
      .then(() => {
        commit('personalNotes', personalNotes)
      })
    },
    deleteProjectNote ({ commit, state, getters, dispatch }, payload) {
      const index = state.projectNotes.findIndex(i => i.id === payload.note.id)
      db.collection('projects').doc(payload.project.id).collection('notes').doc(payload.note.id).update({ deleted: true }).then(() => {
        commit('deleteProjectNote', index)
        const logData = { timestamp: new Date(), collection: 'project notes', user_id: getters.user.id, record_id: payload.project.id, message: getters.user.first_name + ' deleted the note (' + payload.note.note + ') from the project: ' + payload.project.name, icon: 'library_books' }
        dispatch('commitLog', logData)
      })
    },
    updateContactNotes ({ commit, state, getters, dispatch }, payload) {
      db.collection('contacts').doc(payload.contactId).update({ opportunities: payload.allOpps }).then(() => {
        if (payload.action === 'added') {
          payload.createdNote.created_date = { seconds: new Date().getTime() }
          payload.createdNote.createdBy = getters.user
          payload.createdNote.phase = payload.phase
          commit('newLeadNote', payload.createdNote)
        }
        if (payload.action === 'deleted') {
          const stateIndex = state.leadNotes.findIndex(i => i.note === payload.noteChanged)
          commit('deleteLeadNote', stateIndex)
        }
        const logData = { timestamp: new Date(), collection: 'contacts', type: payload.action + ' note', user_id: getters.user.id, record_id: payload.contactId, message: getters.user.first_name + ' ' + payload.action + ' a note (' + payload.noteChanged + ') from the lead: ' + payload.contactName, icon: 'library_books' }
        dispatch('commitLog', logData)
      })
    },
    getLeadNotes ({ commit, getters, dispatch, state }, payload) {
      state.leadNotes = []
      if (payload && payload.opportunities && payload.opportunities.notes) {
        const userList = getters.userList.concat(getters.inactiveUsers)
        const getNotes = payload.opportunities.notes.filter(f => f.deleted === false)
        if (payload.opportunities.revertedToLeads) { // If this is a reverted project to lead with notes.
          dispatch('getProjectNotes', payload.opportunities.revertedToLeads).then(() => {
            getters.projectNotes.forEach(note => {
              let createdBy = userList.filter(f => f.id === note.created_by)
              commit('getLeadNotes', { ...note, createdBy: createdBy[0], source: 'Project' })
            })
            if (getNotes) {
              const projectNotes = state.leadNotes.map(n => n.note)
              getNotes.forEach(note => {
                if (projectNotes.includes(note.note)) { // Avoids note duplication from PREVIOUS lead notes.
                } else {
                  let createdBy = userList.filter(f => f.id === note.created_by)
                  commit('getLeadNotes', { ...note, createdBy: createdBy[0], source: 'Lead' })
                }
              })
            }
          })
        }
        if (getNotes && !payload.opportunities.revertedToLeads) {
          getNotes.forEach(note => {
            let createdBy = userList.filter(f => f.id === note.created_by)
            commit('getLeadNotes', { ...note, createdBy: createdBy[0], source: 'Lead' })
          })
        }
      }
    },
    getProjectNotes ({ commit, getters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        let projectNotes = []
        db.collection('projects').doc(payload).collection('notes').where('deleted', '==', false).get().then(query => {
          query.forEach(note => {
            projectNotes.push({ ...note.data(), id: note.id })
          })
        })
          .then(() => {
            commit('getProjectNotes', projectNotes)
            resolve()
          })
          .catch(error => console.log('An Error Occured Getting Notes. Try Again. Error: ', error))
      })
    },
    addProjectNote ({ commit, getters, dispatch }, payload) {
      let dataObject = {
        note: payload.note,
        created_date: new Date(),
        created_by: getters.user.id,
        deleted: false,
        phase: payload.phase
      }
      if (payload.task_id) {
        dataObject = { ...dataObject, task_id: payload.task_id, task_name: payload.task_name }
      }
      if (payload.flagged) {
        dataObject = { ...dataObject, flagged: payload.flagged }
      }
      db.collection('projects').doc(payload.project_id).collection('notes').add(dataObject)
        .then(docRef => {
          const newPayload = { ...dataObject, id: docRef.id, created_date: { seconds: new Date().getTime() } }
          commit('addProjectNote', newPayload)
          const logData = { timestamp: new Date(), collection: 'project - notes', type: 'created', user_id: getters.user.id, record_id: payload.project_id + ' - ' + docRef.id, message: getters.user.first_name + ' added a note to the project: ' + payload.project_name, icon: 'library_books' }
          dispatch('commitLog', logData)
        })
        .catch(error => console.log('There was an error writing the note to the database. Error: ', error))
    }
  },
  getters: {
    personalNotes (state) {
      return state.personalNotes
    },
    leadNotes (state) {
      return state.leadNotes
    },
    projectNotes (state) {
      return state.projectNotes
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/notes.js